<!-- Contenido Principal -->
<ng-template #mainTpl>
  @if(loading) {
    <nz-skeleton style="padding: 32px" [nzActive]="true" [nzParagraph]="{rows: 4}" ></nz-skeleton>
  } @else {
    <div class="main-content flex flex-column">
      @if (!(isMobile$ | async)) {
        <div class="stepper">

          <div class="stepper-item red-hover" [style.color]="project.status === 'NonValidated' ? '#CB2A2F' : null"
               (click)="!!this.authService.loggedUser$.value?.editProject ? openStateChangeConfirmation('NonValidated') : null">
            <app-st-icon [bold]="true" name="close"></app-st-icon>
            <span>No validado</span>
          </div>

          <app-st-icon name="keyboard_arrow_right"></app-st-icon>

          <div class="stepper-item purple-hover" [style.color]="project.status === 'Validated' ? '#7820BC' : null"
               (click)="!!this.authService.loggedUser$.value?.editProject ? openStateChangeConfirmation('Validated') : null">
            <app-st-icon [bold]="true" name="verified"></app-st-icon>
            <span>Validado</span>
          </div>

          <app-st-icon name="keyboard_arrow_right"></app-st-icon>

          <div class="stepper-item pink-hover" [style.color]="project.status === 'Planning' ? '#BD2864' : null"
               (click)="!!this.authService.loggedUser$.value?.editProject ? openStateChangeConfirmation('Planning') : null">
            <app-st-icon [bold]="true" name="event_upcoming"></app-st-icon>
            <span>Planificación</span>
          </div>

          <app-st-icon name="keyboard_arrow_right"></app-st-icon>

          <div class="stepper-item blue-hover" [style.color]="project.status === 'InExecution' ? '#0068D6' : null"
               (click)="!!this.authService.loggedUser$.value?.editProject ? openStateChangeConfirmation('InExecution') : null">
            <app-st-icon [bold]="true" name="motion_play"></app-st-icon>
            <span>En ejecución</span>
          </div>

          <!--      <app-st-icon name="keyboard_arrow_right"></app-st-icon>-->

          <!--      <div class="stepper-item" [ngClass]="{'active': project.status === 'PaymentStatus'}" (click)="setState('PaymentStatus')">-->
          <!--        <app-st-icon [bold]="true" name="price_change"></app-st-icon>-->
          <!--        <span>Estado de pago</span>-->
          <!--      </div>-->

          <app-st-icon name="keyboard_arrow_right"></app-st-icon>

          <div class="stepper-item teal-hover" [style.color]="project.status === 'Finalized' ? '#067A6E' : null"
               (click)="!!this.authService.loggedUser$.value?.editProject ? openStateChangeConfirmation('Finalized') : null">
            <app-st-icon [bold]="true" name="check_circle"></app-st-icon>
            <span>Finalizado</span>
          </div>
        </div>
      }

      @if (project) {
        <app-project-tabset [project]="project" [activeTabIndex]="selectedTabIndex" ></app-project-tabset>
      }
    </div>
  }
</ng-template>


<ng-template #sideTpl>
  @if(loading) {
    <nz-skeleton style="padding: 32px" [nzActive]="true" [nzParagraph]="{rows: 4}" ></nz-skeleton>
  } @else {
    <!-- Contenido Secundario -->
    @if (project && !loading) {
      <div class="side-content">
        @if (!(isMobile$ | async)) {
          <p class="text-head-16 text-semibold" style="margin-bottom: 20px; padding-right: 48px;">{{project.name}}</p>
        }
        <app-list-key-value [keysWidth]="{value: ((isMobile$ | async) ? 136 : 120), unit: 'px'}"
                            [innerRowGap]="{value: ((isMobile$ | async) ? 0 : 16), unit: 'px'}"
                            [innerColumnGap]="{value: 16, unit: 'px'}"
                            [data]="setKeyValueData()"></app-list-key-value>
      </div>
    } @else {
      <p>No hay datos</p>
    }
  }
</ng-template>

<app-confirmation-modal #confirmationModal (confirmed)="onStateChangeConfirmed($event)"></app-confirmation-modal>
